const JWT_TOKEN = "JWT_TOKEN"

const storeJwtToken = token => {
    localStorage.setItem(JWT_TOKEN, token);
}

const getJwtToken = () => {
    return localStorage.getItem(JWT_TOKEN);
}

const clearJwtToken = () => {
    localStorage.removeItem(JWT_TOKEN);
}

export {getJwtToken, storeJwtToken, clearJwtToken};
